<template>
  <div class="base-circular-loader"
       :class="classes"></div>
</template>

<script>
  export default {
    props: {
      color: {
        required: false,
        type: String,
        default: 'primary'
      },

      size: {
        required: false,
        type: String,
        default: 'medium'
      }
    },
    
    computed: {
      classes() {
        return {
          'is-primary': this.color === 'primary',
          'medium': this.size === 'medium',
          'small': this.size === 'small'
        }
      }
    }
  }
</script>


<style lang="scss" scoped>
  .base-circular-loader {
    display: inline-block;
    width: 64px;
    height: 64px;
  }

  .base-circular-loader:after {
    content: " ";
    display: block;
    margin: 1px;
    width: 46px;
    height: 46px;
    border-radius: 50%;
    border: 5px solid #fff;
    border-color: #fff transparent #fff transparent;
    animation: base-circular-loader 1.2s linear infinite;
  }

  .is-primary::after {
    border: 5px solid map-get($colors , primary);
    border-color: map-get($colors , primary)
      transparent
      map-get($colors , primary)
      transparent;
  }

  .small {
    width: 64px;
    height: 64px;

    &:after {
      width: 54px;
      height: 54px;
    }
  }

  .medium {
    width: 100px;
    height: 100px;

    &:after {
      width: 90px;
      height: 90px;
    }
  }
  
  @keyframes base-circular-loader {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
